// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Quotes: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 34">
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M7.937 8.5h10.625c.585 0 1.063-.478 1.063-1.063 0-.584-.478-1.062-1.063-1.062H16.91c.364-.628.59-1.347.59-2.125a4.25 4.25 0 1 0-8.5 0c0 .778.224 1.497.59 2.125H7.936c-.584 0-1.062.478-1.062 1.063 0 .584.478 1.062 1.062 1.062Zm5.313-6.375c1.171 0 2.125.954 2.125 2.125a2.128 2.128 0 0 1-2.125 2.125 2.128 2.128 0 0 1-2.125-2.125 2.13 2.13 0 0 1 2.125-2.125ZM21.667 4c-.6 0-1.084.48-1.084 1.071 0 .593.488 1.072 1.084 1.072 1.194 0 2.166.96 2.166 2.143v21.428c0 1.183-.972 2.143-2.166 2.143H4.333c-1.194 0-2.166-.96-2.166-2.143V8.286c0-1.183.972-2.143 2.166-2.143.6 0 1.084-.48 1.084-1.072C5.417 4.48 4.932 4 4.333 4 1.943 4 0 5.923 0 8.286v21.428C0 32.077 1.943 34 4.333 34h17.334C24.057 34 26 32.077 26 29.714V8.286C26 5.923 24.057 4 21.667 4ZM5.28 17a1.594 1.594 0 1 0 3.189 0 1.594 1.594 0 0 0-3.189 0Zm1.594 4.781a1.594 1.594 0 1 0 0 3.188 1.594 1.594 0 0 0 0-3.188Zm13.813-5.843h-8.5c-.585 0-1.063.478-1.063 1.062 0 .584.475 1.063 1.063 1.063h8.5c.584 0 1.062-.479 1.062-1.063s-.478-1.063-1.062-1.063Zm0 6.374h-8.5a1.064 1.064 0 0 0 0 2.125h8.5a1.062 1.062 0 1 0 0-2.125Z"
            />
        </svg>
    );
};

export default React.memo(Quotes);
